import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroContactRequestForm.FinancialDetailsPart', {
    currencyTitle: 'Currency',
    batchPaymentTitle: 'Batch Payment',
    baseCurrency: 'Base currency',
    baseCurrencyPlaceholder: 'Select Base currency',
    sortCode: 'Sort code',
    sortCodePlaceholder: 'Enter Sort code',
    bankAccountNumber: 'Bank account number',
    bankAccountNumberPlaceholder: 'Enter Bank account number',
});
